import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createWarningAPI,
  deleteWarningAPI,
  getWarningsAPI,
} from "@/apis/warning/warning-apis";
import type { WarningCreate } from "@/domain/warning";
import { queryKeys } from "./keys";

export function useWarnings(cityId: number | null) {
  return useQuery({
    queryKey: queryKeys.warnings.list(cityId ?? 0),
    // Query is disabled when cityId is null, so queryFn won't run with fallback value
    queryFn: () => getWarningsAPI(cityId ?? 0),
    enabled: cityId !== null,
  });
}

export function useCreateWarning() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ cityId, dto }: { cityId: number; dto: WarningCreate }) =>
      createWarningAPI(cityId, dto),
    onSuccess: (_, { cityId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.warnings.list(cityId),
      });
    },
  });
}

export function useDeleteWarning() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteWarningAPI(id),
    onSuccess: () => {
      // Invalidate all warning lists (unknown which cityId this warning belongs to)
      queryClient.invalidateQueries({
        queryKey: queryKeys.warnings.all,
        predicate: (query) => query.queryKey[1] === "list",
      });
    },
  });
}
